import { Component, OnInit, Input } from '@angular/core';
//import { FormGroup } from '@angular/forms';
import { IWorkItem } from '../../shared/workItem';

@Component({
  selector: 'app-compare-grid',
  templateUrl: './compare-grid.component.html',
  styleUrls: ['./compare-grid.component.css']
})
export class CompareGridComponent implements OnInit {

  @Input() workitems: IWorkItem[];

  constructor() { }

  ngOnInit() {

  }

}
